<template>
    <section>
        <NotificationMessenger ref="notification" :message="notificationMessage" />

        <div class="titulo">
            <div class="margem container">
                <h2>Edição de apontamento</h2>
            </div>
        </div>

        <div class="margem container">
            <div class="bloco margem">
                <div class="margem container painel-edicao-op-picker">
                    <div class="painel-edicao-tipo-chips" role="group" aria-label="Tipo de apontamento">
                        <button
                            type="button"
                            class="painel-edicao-op-chip"
                            :class="{ 'painel-edicao-op-chip--ativo': referenceType === 'op' }"
                            @click="setReferenceType('op')"
                        >
                            OP
                        </button>
                        <button
                            type="button"
                            class="painel-edicao-op-chip"
                            :class="{ 'painel-edicao-op-chip--ativo': referenceType === 'os' }"
                            @click="setReferenceType('os')"
                        >
                            OS Tryout
                        </button>
                    </div>
                    <h3>{{ pickerTitle }}</h3>
                    <div class="painel-edicao-op-picker-linha">
                        <SearchableSelect v-model="selectedOpOption" :options="pickerOptions" />
                        <button
                            v-if="selectedOpOption"
                            type="button"
                            class="painel-edicao-op-limpar"
                            title="Limpar seleção"
                            @click="limparSelecaoOp"
                        >
                            Limpar
                        </button>
                    </div>
                    <div v-if="abertosChips.length" class="painel-edicao-op-abertos">
                        <p class="painel-edicao-op-abertos__titulo fonte-fraca fonte-menor">
                            {{ abertosChipsTitulo }}
                        </p>
                        <div class="painel-edicao-op-abertos__chips" role="list">
                            <button
                                v-for="item in abertosChips"
                                :key="item.id"
                                type="button"
                                role="listitem"
                                class="painel-edicao-op-chip"
                                :class="{ 'painel-edicao-op-chip--ativo': selectedOpId === String(item.id) }"
                                :title="item.option.label"
                                @click="selecionarAbertaChip(item)"
                            >
                                {{ item.label }}
                            </button>
                        </div>
                    </div>
                </div>
                <h2>{{ headerTitle }}</h2>
                <div class="grid-4 margem">
                    <div v-if="isOsMode" class="bloco margem">
                        <div class="fonte-fraca">Código OS</div>
                        <h3>{{ injectionOrder.code ?? "—" }}</h3>
                    </div>
                    <div v-if="isOsMode" class="bloco margem">
                        <div class="fonte-fraca">Categoria</div>
                        <h3>{{ injectionOrder.categoriaNome ?? "—" }}</h3>
                    </div>
                    <div v-if="isOsMode" class="bloco margem">
                        <div class="fonte-fraca">Cliente</div>
                        <h3>{{ injectionOrder.clientName || "—" }}</h3>
                    </div>
                    <div class="bloco margem">
                        <div class="fonte-fraca">{{ isOsMode ? "Data fim prevista" : "Data de entrega" }}</div>
                        <h3>
                            {{
                                parseDate(
                                    isOsMode ? (injectionOrder.dtFimPrevisto ?? null) : (injectionOrder.deliveryDate ?? null),
                                    false
                                )
                            }}
                        </h3>
                    </div>
                    <div v-if="!isOsMode" class="bloco margem">
                        <div class="fonte-fraca">Quantidade prevista</div>
                        <h3>{{ injectionOrder.quantityExpected }}</h3>
                    </div>
                    <div class="bloco margem">
                        <div class="fonte-fraca">Quantidade produzida</div>
                        <h3>{{ injectionOrder.quantityProduced }}</h3>
                    </div>
                    <div v-if="!isOsMode" class="bloco margem">
                        <div class="fonte-fraca">Peças boas</div>
                        <h3>{{ goodParts }}</h3>
                    </div>

                    <div class="margem bloco">
                        <label class="fonte-fraca">Refugo produzido</label>
                        <h3>{{ totalRefugoKg }}</h3>
                    </div>
                    <div class="margem bloco">
                        <label class="fonte-fraca">Borra produzida</label>
                        <h3>{{ totalBorraKg }}</h3>
                    </div>
                    <div class="margem bloco">
                        <label class="fonte-fraca">Galho produzido</label>
                        <h3>{{ totalGalhoKg }}</h3>
                    </div>
                </div>
            </div>

            <div v-if="isLoading" class="loading"><div></div></div>

            <div v-if="!isLoading" class="bloco margem">
                <table class="tabela">
                    <tbody>
                        <tr>
                            <th>Data inicio</th>
                            <th>Data fim</th>
                            <th>Tipo de trabalho</th>
                            <th class="painel-edicao-col-maquina">Maquina</th>
                            <th class="painel-edicao-col-num-compact" scope="col">Peças produzidas</th>
                            <th class="painel-edicao-col-num-compact" scope="col">Refugo</th>
                            <th class="painel-edicao-col-num-compact" scope="col">Borra</th>
                            <th class="painel-edicao-col-num-compact" scope="col">Galho</th>
                            <th>Equipe</th>
                            <th class="painel-edicao-col-pausas" scope="col">Pausas</th>
                            <th class="painel-edicao-col-acao" scope="col">
                                <span class="painel-edicao-sr-only">Ações da linha</span>
                            </th>
                        </tr>
                        <tr v-for="(activity, index) in activities" :key="activity.id">
                            <editable-cell
                                :value="activity.startDateTime"
                                :display-value="formatActivityDateTimeTable(activity.startDateTime)"
                                input-type="datetime-local"
                                :index="index"
                                @update:value="applyLocalChange(activity, 'startDateTime', $event)"
                            >
                            </editable-cell>
                            <editable-cell
                                :value="activity.endDateTime"
                                :display-value="formatActivityEndDateTimeTable(activity.endDateTime)"
                                input-type="datetime-local"
                                :index="index"
                                @update:value="applyLocalChange(activity, 'endDateTime', $event)"
                            ></editable-cell>

                            <td>
                                <select @change="(event) => applyLocalChange(activity, 'serviceTypeId', event.target.value)">
                                    <option
                                        v-for="service of services"
                                        :key="service.id"
                                        :value="service.id"
                                        :selected="activity.serviceTypeId === service.id"
                                    >
                                        {{ getServiceType(service.id) }}
                                    </option>
                                </select>
                            </td>

                            <td class="painel-edicao-col-maquina">
                                <select
                                    @change="(event) => applyLocalChange(activity, 'machineId', event.target.value)"
                                >
                                    <option
                                        v-for="machine of machines"
                                        :key="machine.id"
                                        :value="machine.id"
                                        :selected="activity.machineId === machine.id"
                                    >
                                        {{ getMachineName(machine.id) }}
                                    </option>
                                </select>
                            </td>

                            <editable-cell
                                cell-class="painel-edicao-col-num-compact"
                                :value="parseInt(activity.quantityProduced)"
                                :display-value="parseInt(activity.quantityProduced)"
                                input-type="number"
                                :index="index"
                                @update:value="applyLocalChange(activity, 'quantityProduced', $event)"
                            ></editable-cell>

                            <editable-cell
                                cell-class="painel-edicao-col-num-compact"
                                :value="formatDecimal(activity.quantityRefugo)"
                                :display-value="formatDecimal(activity.quantityRefugo)"
                                input-type="number"
                                :index="index"
                                @update:value="applyLocalChange(activity, 'quantityRefugo', $event)"
                            ></editable-cell>
                            <editable-cell
                                cell-class="painel-edicao-col-num-compact"
                                :value="formatDecimal(activity.quantityBorra)"
                                :display-value="formatDecimal(activity.quantityBorra)"
                                input-type="number"
                                :index="index"
                                @update:value="applyLocalChange(activity, 'quantityBorra', $event)"
                            >
                            </editable-cell>
                            <editable-cell
                                cell-class="painel-edicao-col-num-compact"
                                :value="formatDecimal(activity.quantityGalho)"
                                :display-value="formatDecimal(activity.quantityGalho)"
                                input-type="number"
                                :index="index"
                                @update:value="applyLocalChange(activity, 'quantityGalho', $event)"
                            ></editable-cell>

                            <td
                                @click="toggleTeamDropdown(activity)"
                                class="clicavel"
                                @focusout="handleFocusOut(activity)"
                                tabindex="0"
                            >
                                <div>
                                    <div>{{ parseTeamMembersName(activity) }}</div>
                                    <div class="dropdown" @click.stop>
                                        <div class="dropdown-content" v-show="activity.isDropdownVisible">
                                            <label
                                                v-for="employee of injectionEmployees"
                                                :key="employee.id"
                                                @click="selectEmployee(activity, employee)"
                                                :value="employee"
                                                class="clicavel"
                                                :class="isEmployeeOnTeam(activity, employee) ? 'bg-blue' : 'bg-yellow'"
                                            >
                                                {{ employee.fullName }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="painel-edicao-col-pausas">
                                <button
                                    type="button"
                                    class="painel-edicao-btn-pausas"
                                    title="Ver e editar pausas e retomadas deste trabalho"
                                    @click="abrirModalPausas(activity)"
                                >
                                    Pausas
                                </button>
                            </td>
                            <td class="painel-edicao-col-acao">
                                <div class="painel-edicao-acoes-linha">
                                    <button
                                        type="button"
                                        class="painel-edicao-btn-salvar-linha"
                                        :title="savingRowId === activity.id ? 'Salvando…' : 'Salvar alterações deste apontamento'"
                                        :aria-label="'Salvar apontamento da linha ' + (index + 1)"
                                        :disabled="!isRowDirty(activity) || savingRowId === activity.id || deletingRowId === activity.id"
                                        @click="saveActivityRow(activity)"
                                    >
                                        <svg
                                            v-if="savingRowId !== activity.id"
                                            class="painel-edicao-icone-salvar"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            width="22"
                                            height="22"
                                            aria-hidden="true"
                                            focusable="false"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4zm-5 16a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm3-10H5V5h10v4z"
                                            />
                                        </svg>
                                        <span v-else class="painel-edicao-salvando" aria-hidden="true">…</span>
                                    </button>
                                    <button
                                        type="button"
                                        class="painel-edicao-btn-excluir-linha"
                                        title="Excluir este apontamento"
                                        :aria-label="'Excluir apontamento da linha ' + (index + 1)"
                                        :disabled="deletingRowId === activity.id || savingRowId === activity.id"
                                        @click="excluirApontamento(activity)"
                                    >
                                        <span v-if="deletingRowId === activity.id" class="painel-edicao-salvando" aria-hidden="true">…</span>
                                        <svg
                                            v-else
                                            class="painel-edicao-icone-excluir"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            width="20"
                                            height="20"
                                            aria-hidden="true"
                                            focusable="false"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!isOsMode && selectedOpId && !injectionOrder.isFinished" class="alinha-direita">
                    <button @click="finishOp">Finalizar OP</button>
                </div>
                <div v-if="isOsMode && selectedOpId && !osJaFinalizada" class="alinha-direita">
                    <button type="button" :disabled="finalizandoOs" @click="finishOs">
                        {{ finalizandoOs ? "Finalizando..." : "Finalizar OS" }}
                    </button>
                </div>
                <div
                    v-if="!isOsMode && selectedOpId && injectionOrder.isFinished"
                    class="alinha-direita"
                    style="flex-wrap: wrap; align-items: center; gap: 12px"
                >
                    <p v-if="opJaConcluidaCrm" class="fonte-fraca" style="margin: 0; flex: 1 1 100%; max-width: 42rem">
                        Esta OP já foi concluída no sistema (CRM). Não é possível enviar nova conclusão por aqui.
                    </p>
                    <button
                        type="button"
                        :disabled="opJaConcluidaCrm"
                        :title="opJaConcluidaCrm ? 'OP já concluída' : ''"
                        @click="abrirEncerrarOpOmie"
                        style="margin-right: 20px"
                    >
                        Encerrar OP Omie
                    </button>
                    <button type="button" @click="reopenOp">Reabrir OP</button>
                </div>
            </div>
        </div>
    </section>

    <ModalPausasTrabalho
        :show="modalPausasTrabalho.show"
        :trabalho-id="modalPausasTrabalho.trabalhoId"
        @close="fecharModalPausasTrabalho"
        @error="onModalPausasError"
        @saved="onModalPausasSaved"
    />

    <SimpleModal :show="encerrarOmieModalVisivel" @close="!concluindoOmie && fecharEncerrarOpOmie()">
        <div class="encerrar-omie-modal">
            <h3>Encerrar OP Omie — {{ injectionOrder.opNum ?? selectedOpId }}</h3>
            <p v-if="opJaConcluidaCrm" class="encerrar-omie-info" style="color: var(--cor-erro, #b91c1c); font-weight: 600">
                Esta OP já foi concluída. Confirmação desabilitada.
            </p>
            <p v-else class="encerrar-omie-info">
                Data de conclusão: <strong>{{ dataConclusaoHoje }}</strong><br />
                Quantidade produzida (apontada pelos operadores): <strong>{{ quantityProducedForOmie }}</strong>
            </p>
            <div class="encerrar-omie-field">
                <label>Observação (enviada ao Omie)</label>
                <textarea
                    v-model="encerrarOmieObs"
                    placeholder="Observação de conclusão (máx. 500 caracteres)"
                    maxlength="500"
                    rows="4"
                />
            </div>
            <div class="linha encerrar-omie-actions">
                <button class="acao-secundaria" :disabled="concluindoOmie" @click="fecharEncerrarOpOmie">Cancelar</button>
                <button :disabled="concluindoOmie || opJaConcluidaCrm" @click="confirmarEncerrarOpOmie">
                    {{ concluindoOmie ? "Encerrando..." : "Encerrar OP Omie" }}
                </button>
            </div>
        </div>
    </SimpleModal>
</template>

<script>
import NotificationMessenger from "@/components/NotificationMessenger.vue";
import { EditarApontamentoDatasource } from "@/data/datasource/ApontamentoDatasource";
import OpDataSource from "@/data/datasource/OpDataSource";
import InconformidadeDataSource from "@/data/datasource/InconformidadeDataSource";
import EditableCell from "@/components/EditableCell.vue";
import ModalPausasTrabalho from "@/components/ModalPausasTrabalho.vue";
import { SearchableSelect, SimpleModal } from "roboflex-thalamus-componentes-vue3-lib";
import { sso } from "roboflex-thalamus-sso-lib";
import { InjectionActivityModel } from "@/data/model/InjectionActivityModel";
import { buildTrabalhoCorrecaoPayload, snapshotTrabalhoEdicao } from "@/data/utils/trabalhoCorrecaoPatch";

const dataSource = new EditarApontamentoDatasource();

export default {
    data() {
        return {
            notificationMessage: "",
            /** 'op' (padrão) ou 'os' — mesmo comportamento do app injetora */
            referenceType: "op",
            ops: [],
            osList: [],
            machines: [],
            services: [],
            injectionEmployees: [],
            selectedOpId: null,
            /** Opção selecionada no autocomplete (objeto com id, opNum, label, …) */
            selectedOpOption: null,
            selectedEmployees: [],
            injectionOrder: { productName: "" },
            activities: [],
            totalInconformesOp: 0,
            childComponent: "component",
            usuario: null,
            isLoading: true,
            encerrarOmieModalVisivel: false,
            encerrarOmieObs: "",
            concluindoOmie: false,
            finalizandoOs: false,
            /** Snapshot JSON por trabalho.id após carregar / salvar linha */
            rowBaselines: {},
            savingRowId: null,
            deletingRowId: null,
            modalPausasTrabalho: { show: false, trabalhoId: null },
            /** Lista do endpoint op-com-trabalho-aberto: { op_cod, opNum } */
            opsAbertosRaw: [],
            /** Lista do endpoint os-com-trabalho-aberto: { os_id, codigo } */
            osAbertosRaw: [],
        };
    },
    components: {
        NotificationMessenger,
        EditableCell,
        ModalPausasTrabalho,
        SearchableSelect,
        SimpleModal,
    },
    computed: {
        isOsMode() {
            return this.referenceType === "os";
        },
        osJaFinalizada() {
            return String(this.injectionOrder?.status ?? "").trim().toLowerCase() === "concluída";
        },
        pickerTitle() {
            return this.isOsMode ? "Selecione a OS Tryout" : "Selecione a OP";
        },
        headerTitle() {
            const order = this.injectionOrder;
            if (!order) return "";
            if (this.isOsMode) {
                const code = order.productCode || order.code || "";
                const name = order.productName || (order.produtos?.length ? order.produtos.join(", ") : "");
                const parts = [code, name].filter((p) => p != null && String(p).trim() !== "");
                return parts.length ? parts.join(" - ") : `OS ${order.code ?? order.id ?? ""}`;
            }
            return `${order.productCode ?? ""} - ${order.productName ?? ""}`.trim();
        },
        pickerOptions() {
            return this.isOsMode ? this.osPickerOptions : this.opPickerOptions;
        },
        dataConclusaoHoje() {
            const d = new Date();
            const day = String(d.getDate()).padStart(2, "0");
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const year = d.getFullYear();
            return `${day}/${month}/${year}`;
        },
        quantityProducedForOmie() {
            const q = this.injectionOrder?.quantityProduced;
            return q != null && q !== "" ? Number(q) : 0;
        },
        goodParts() {
            const produced = this.quantityProducedForOmie;
            const inconformes = this.totalInconformesOp || 0;
            return Math.max(0, produced - inconformes);
        },
        /** Totais = soma dos apontamentos (trabalhos); fallback no cabeçalho da OP se não houver linhas */
        totalBorraKg() {
            return `${this.sumActivitiesKg("quantityBorra").toFixed(2)}Kg`;
        },
        totalRefugoKg() {
            return `${this.sumActivitiesKg("quantityRefugo").toFixed(2)}Kg`;
        },
        totalGalhoKg() {
            return `${this.sumActivitiesKg("quantityGalho").toFixed(2)}Kg`;
        },
        defaultRemarkBorraRefugoGalho() {
            const b = this.sumActivitiesKg("quantityBorra");
            const r = this.sumActivitiesKg("quantityRefugo");
            const g = this.sumActivitiesKg("quantityGalho");
            return `Borra: ${b.toFixed(2)} kg, Refugo: ${r.toFixed(2)} kg, Galho: ${g.toFixed(2)} kg`;
        },
        /** OP já passou por crm-producao/op/conclui (campo producao.concluida) */
        opJaConcluidaCrm() {
            return Number(this.injectionOrder?.concluida) === 1;
        },
        /** OPs com texto de busca (número, produto, cliente). */
        opPickerOptions() {
            return (this.ops ?? []).map((op) => this.mapOpToPickerOption(op));
        },
        /** OS tryout com código, produto e cliente. */
        osPickerOptions() {
            return (this.osList ?? []).map((os) => this.mapOsToPickerOption(os));
        },
        /** Chips: OPs com ao menos um trabalho de injeção sem data fim. */
        opsAbertosChips() {
            const raw = this.opsAbertosRaw ?? [];
            return raw.map((row) => {
                const opCod = row.op_cod;
                const op = this.ops.find((o) => String(o.id) === String(opCod));
                const opNum = row.opNum != null && row.opNum !== "" ? row.opNum : op?.opNum ?? opCod;
                const option = op
                    ? this.mapOpToPickerOption(op)
                    : {
                          id: opCod,
                          opNum,
                          productCode: "",
                          productName: "",
                          clientName: "",
                          label: `OP ${opNum}`,
                      };
                return { id: opCod, label: opNum, option };
            });
        },
        /** Chips: OS tryout com ao menos um trabalho de injeção sem data fim. */
        osAbertosChips() {
            const raw = this.osAbertosRaw ?? [];
            return raw.map((row) => {
                const osId = row.os_id;
                const os = this.osList.find((o) => String(o.id) === String(osId));
                const codigo = row.codigo != null && row.codigo !== "" ? row.codigo : os?.code ?? osId;
                const option = os
                    ? this.mapOsToPickerOption(os)
                    : {
                          id: osId,
                          code: codigo,
                          productCode: "",
                          productName: "",
                          clientName: "",
                          label: `OS ${codigo}`,
                      };
                return { id: osId, label: codigo, option };
            });
        },
        abertosChipsTitulo() {
            return this.isOsMode
                ? "OSs com apontamento em aberto (trabalho sem data fim)"
                : "OPs com apontamento em aberto (trabalho sem data fim)";
        },
        abertosChips() {
            return this.isOsMode ? this.osAbertosChips : this.opsAbertosChips;
        },
    },
    watch: {
        selectedOpOption(newVal) {
            if (newVal == null) return;
            const id = newVal.id != null ? String(newVal.id) : "";
            if (id === "") return;
            if (this.isOsMode) {
                this.getOsData(id);
            } else {
                this.getOpData(id);
            }
        },
    },
    async created() {
        this.usuario = sso.getUsuarioLogado();
        await this.fetchInitialData();
    },

    methods: {
        mapOpToPickerOption(op) {
            const parts = [op.opNum, op.productCode, op.productName, op.clientName].filter(
                (p) => p != null && String(p).trim() !== ""
            );
            return {
                ...op,
                label: parts.length ? parts.join(" · ") : `OP ${op.id}`,
            };
        },

        mapOsToPickerOption(os) {
            const parts = [os.code, os.productCode, os.productName, os.clientName].filter(
                (p) => p != null && String(p).trim() !== ""
            );
            return {
                ...os,
                label: parts.length ? parts.join(" · ") : `OS ${os.code ?? os.id}`,
            };
        },

        async setReferenceType(type) {
            if (this.referenceType === type) return;
            this.referenceType = type;
            this.clearSelection();
            this.isLoading = true;
            try {
                await this.fetchReferenceList();
            } finally {
                this.isLoading = false;
            }
        },

        async fetchReferenceList() {
            if (this.isOsMode) {
                this.osList = await dataSource.getActiveOs();
                await this.carregarOsAbertos();
            } else {
                this.ops = await dataSource.getActiveOps();
                await this.carregarOpsAbertos();
            }
        },

        async carregarAbertos() {
            if (this.isOsMode) {
                await this.carregarOsAbertos();
            } else {
                await this.carregarOpsAbertos();
            }
        },

        async reloadSelectedReferenceDetails() {
            if (!this.selectedOpId) return;
            if (this.isOsMode) {
                this.injectionOrder = await dataSource.getOsDetails(this.selectedOpId);
            } else {
                this.injectionOrder = await dataSource.getOpDetails(this.selectedOpId);
            }
        },

        limparSelecaoOp() {
            this.clearSelection();
        },

        async carregarOpsAbertos() {
            try {
                this.opsAbertosRaw = await dataSource.getOpsComTrabalhoAberto();
            } catch (e) {
                console.warn("carregarOpsAbertos:", e);
                this.opsAbertosRaw = [];
            }
        },

        async carregarOsAbertos() {
            try {
                this.osAbertosRaw = await dataSource.getOsComTrabalhoAberto();
            } catch (e) {
                console.warn("carregarOsAbertos:", e);
                this.osAbertosRaw = [];
            }
        },

        selecionarAbertaChip(item) {
            if (!item?.option) return;
            this.selectedOpOption = { ...item.option };
        },

        async fetchInitialData() {
            this.isLoading = true;
            try {
                const [, machines, services, employees] = await Promise.all([
                    this.fetchReferenceList(),
                    dataSource.getMachines(),
                    dataSource.getServicesType(),
                    dataSource.getInjetionEmployees(),
                ]);
                this.machines = machines;
                this.services = services;
                this.injectionEmployees = employees;
            } finally {
                this.isLoading = false;
            }
        },

        clearSelection() {
            this.selectedOpId = null;
            this.selectedOpOption = null;
            this.injectionOrder = { productName: "" };
            this.activities = [];
            this.totalInconformesOp = 0;
            this.rowBaselines = {};
        },

        async getOsData(osId) {
            const id = osId === "" || osId == null ? "" : String(osId);
            if (id === "") {
                this.clearSelection();
                return;
            }
            this.isLoading = true;
            this.injectionOrder = { productName: "" };
            this.activities = [];
            this.totalInconformesOp = 0;
            this.selectedOpId = id;

            try {
                this.injectionOrder = await dataSource.getOsDetails(id);
                this.activities = await dataSource.getActivitiesByOs(id);
                this.captureRowBaselines();
            } catch (e) {
                const data = e.response?.data;
                const msg =
                    data?.msg ||
                    data?.error ||
                    (e.response?.status === 404
                        ? "OS não encontrada ou indisponível para injeção."
                        : null) ||
                    "Não foi possível carregar a OS.";
                this.notificationMessage = typeof msg === "string" ? msg : "Não foi possível carregar a OS.";
                this.$refs.notification.show();
                this.clearSelection();
            } finally {
                this.isLoading = false;
            }
        },

        async getOpData(opId) {
            const id = opId === "" || opId == null ? "" : String(opId);
            if (id === "") {
                this.clearSelection();
                return;
            }
            this.isLoading = true;
            this.injectionOrder = { productName: "" };
            this.activities = [];
            this.totalInconformesOp = 0;
            this.selectedOpId = id;

            try {
                this.injectionOrder = await dataSource.getOpDetails(id);
                this.activities = await dataSource.getActivities(id);
                this.captureRowBaselines();
                this.totalInconformesOp = await InconformidadeDataSource.getTotalQuantidadePorOp(Number(id));
            } catch (e) {
                const data = e.response?.data;
                const msg =
                    data?.msg ||
                    data?.error ||
                    (e.response?.status === 404 ? "OP não encontrada ou já concluída (indisponível para injeção)." : null) ||
                    "Não foi possível carregar a OP.";
                this.notificationMessage = typeof msg === "string" ? msg : "Não foi possível carregar a OP.";
                this.$refs.notification.show();
                this.clearSelection();
            } finally {
                this.isLoading = false;
            }
        },

        parseDate(date, withHour) {
            if (date != null) {
                if (withHour) {
                    date = new Date(date).toLocaleString();
                } else {
                    date = new Date(date).toLocaleDateString();
                }
            } else {
                date = "-";
            }
            return date;
        },

        /** Exibição na tabela: dia/mês + hora:minuto (sem ano, sem segundos). */
        formatActivityDateTimeTable(date) {
            if (date == null || date === "") return "—";
            const d = new Date(date);
            if (Number.isNaN(d.getTime())) return "—";
            return new Intl.DateTimeFormat("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            }).format(d);
        },

        /** Data fim na tabela: mesmo formato; vazio/inválido = Em aberto. */
        formatActivityEndDateTimeTable(date) {
            if (date == null || date === "") return "Em aberto";
            const d = new Date(date);
            if (Number.isNaN(d.getTime())) return "Em aberto";
            return new Intl.DateTimeFormat("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            }).format(d);
        },

        getMachineName(machineId) {
            const machine = this.machines.find((m) => m.id === machineId);
            return machine ? `${machine.name ?? ""}`.trim() : "-";
        },

        getServiceType(serviceId) {
            const service = this.services.find((s) => s.id === serviceId);
            return service?.description ?? "-";
        },

        formatDecimal(val) {
            const n = parseFloat(val ?? 0);
            return isNaN(n) ? "0.00" : n.toFixed(2);
        },

        /**
         * Soma um campo numérico em todas as atividades (trabalhos).
         * Se não houver linhas, usa o total vindo do detalhe da OP (API).
         */
        sumActivitiesKg(field) {
            const rows = this.activities;
            if (!Array.isArray(rows) || rows.length === 0) {
                const n = parseFloat(this.injectionOrder?.[field] ?? 0);
                return isNaN(n) ? 0 : n;
            }
            return rows.reduce((acc, a) => acc + (parseFloat(a?.[field]) || 0), 0);
        },

        captureRowBaselines() {
            const next = {};
            for (const a of this.activities) {
                if (a.id != null) next[a.id] = snapshotTrabalhoEdicao(a);
            }
            this.rowBaselines = next;
        },

        isRowDirty(activity) {
            if (activity?.id == null) return false;
            const baseline = this.rowBaselines[activity.id];
            if (baseline === undefined) return false;
            return baseline !== snapshotTrabalhoEdicao(activity);
        },

        async saveActivityRow(activity) {
            if (!this.isRowDirty(activity)) return;
            const id = activity.id;
            const baseline = this.rowBaselines[id];
            if (baseline === undefined) return;
            const payload = buildTrabalhoCorrecaoPayload(activity, baseline);
            if (Object.keys(payload).length === 0) return;

            this.savingRowId = id;
            try {
                const response = await dataSource.updateTrabalhoCorrecao(id, payload);
                if (!(response instanceof InjectionActivityModel)) {
                    this.notificationMessage =
                        typeof response === "string" ? `Erro ao salvar: ${response}` : "Erro ao salvar apontamento.";
                    this.$refs.notification.show();
                    return;
                }
                const idx = this.activities.findIndex((x) => x.id === id);
                if (idx >= 0) {
                    this.activities.splice(idx, 1, response);
                    this.rowBaselines = { ...this.rowBaselines, [id]: snapshotTrabalhoEdicao(this.activities[idx]) };
                }
                this.notificationMessage = "Apontamento salvo.";
                this.$refs.notification.show();
                await this.carregarAbertos();
            } catch (e) {
                const msg = e?.response?.data?.error ?? e?.response?.data?.msg ?? e?.message ?? "Erro ao salvar apontamento.";
                this.notificationMessage = typeof msg === "string" ? msg : "Erro ao salvar apontamento.";
                this.$refs.notification.show();
            } finally {
                this.savingRowId = null;
            }
        },

        async excluirApontamento(activity) {
            const id = activity?.id;
            if (id == null) return;
            const refLabel = this.isOsMode ? "OS" : "OP";
            const ok = window.confirm(
                `Excluir o apontamento (trabalho) nº ${id}?\n\n` +
                    `A exclusão é lógica: some desta lista e dos totais da ${refLabel}, mas o registro permanece no sistema.`,
            );
            if (!ok) return;
            this.deletingRowId = id;
            try {
                const msg = await dataSource.excluirTrabalhoInjecao(id);
                if (this.modalPausasTrabalho.show && this.modalPausasTrabalho.trabalhoId === id) {
                    this.modalPausasTrabalho = { show: false, trabalhoId: null };
                }
                this.activities = this.activities.filter((a) => a.id !== id);
                const restBaselines = { ...this.rowBaselines };
                delete restBaselines[id];
                this.rowBaselines = restBaselines;
                if (this.selectedOpId) {
                    try {
                        await this.reloadSelectedReferenceDetails();
                    } catch {
                        /* mantém cabeçalho anterior se o detalhe falhar */
                    }
                }
                this.notificationMessage = typeof msg === "string" ? msg : "Apontamento excluído.";
                this.$refs.notification.show();
                await this.carregarAbertos();
            } catch (e) {
                const errMsg =
                    e?.response?.data?.error ?? e?.response?.data?.msg ?? e?.message ?? "Erro ao excluir apontamento.";
                this.notificationMessage = typeof errMsg === "string" ? errMsg : "Erro ao excluir apontamento.";
                this.$refs.notification.show();
            } finally {
                this.deletingRowId = null;
            }
        },

        /** Atualiza só o estado local; persistência pelo ícone salvar na linha. */
        applyLocalChange(activity, field, value) {
            let normalized = value;
            if (field === "quantityProduced") normalized = parseInt(value, 10) || 0;
            else if (field === "quantityBorra" || field === "quantityRefugo" || field === "quantityGalho")
                normalized = parseFloat(value) || 0;
            else if (field === "machineId" || field === "serviceTypeId") {
                const n = parseInt(value, 10);
                if (Number.isNaN(n)) return;
                normalized = n;
            }
            else if (field === "startDateTime") normalized = value ? new Date(value) : activity.startDateTime;
            else if (field === "endDateTime") normalized = value === "" || value == null ? null : new Date(value);
            activity[field] = normalized;
        },

        async finishOp() {
            const opId = this.selectedOpId;
            try {
                const msg = await dataSource.finishOp(opId);
                this.ops = await dataSource.getActiveOps();
                await this.carregarOpsAbertos();
                this.notificationMessage = msg ?? "OP finalizada com sucesso.";
                this.$refs.notification.show();
                this.clearSelection();
            } catch (e) {
                this.notificationMessage = e.response?.data?.error ?? e.response?.data?.msg ?? "Ocorreu um erro ao finalizar OP.";
                this.$refs.notification.show();
            }
        },

        async finishOs() {
            const osId = this.selectedOpId;
            if (osId == null || osId === "") return;
            const codigo = this.injectionOrder?.code ?? osId;
            const ok = window.confirm(
                `Finalizar a OS ${codigo}? O item de demanda ficará como Concluído e as datas de execução serão registradas.`,
            );
            if (!ok) return;
            this.finalizandoOs = true;
            try {
                const msg = await dataSource.finishOs(osId);
                this.osList = await dataSource.getActiveOs();
                await this.carregarAbertos();
                this.notificationMessage = msg ?? "OS finalizada com sucesso.";
                this.$refs.notification.show();
                this.clearSelection();
            } catch (e) {
                this.notificationMessage =
                    e.response?.data?.error ?? e.response?.data?.msg ?? e.message ?? "Ocorreu um erro ao finalizar OS.";
                this.$refs.notification.show();
            } finally {
                this.finalizandoOs = false;
            }
        },

        abrirEncerrarOpOmie() {
            if (this.opJaConcluidaCrm) {
                this.notificationMessage = "Esta OP já foi concluída no sistema. Não é possível enviar nova conclusão.";
                this.$refs.notification.show();
                return;
            }
            this.encerrarOmieObs = this.defaultRemarkBorraRefugoGalho;
            this.encerrarOmieModalVisivel = true;
        },

        fecharEncerrarOpOmie() {
            this.encerrarOmieModalVisivel = false;
            this.encerrarOmieObs = "";
        },

        async confirmarEncerrarOpOmie() {
            if (this.opJaConcluidaCrm) {
                this.notificationMessage = "Esta OP já foi concluída no sistema.";
                this.$refs.notification.show();
                return;
            }
            const opId = this.selectedOpId;
            if (opId == null || opId === "") {
                this.notificationMessage = "OP não selecionada.";
                this.$refs.notification.show();
                return;
            }
            const quantity = this.quantityProducedForOmie;
            if (Number.isNaN(quantity) || quantity < 0) {
                this.notificationMessage = "Quantidade produzida inválida.";
                this.$refs.notification.show();
                return;
            }
            this.concluindoOmie = true;
            try {
                await OpDataSource.concluirOpOmie({
                    op_cod: Number(opId),
                    // dDtConclusao: this.dataConclusaoHoje,
                    // nQtdeProduzida: quantity,
                    obs: (this.encerrarOmieObs || "").trim().slice(0, 500) || undefined,
                });
                this.notificationMessage = "OP concluída com sucesso.";
                this.$refs.notification.show();
                this.injectionOrder = { ...this.injectionOrder, concluida: 1 };
                this.fecharEncerrarOpOmie();
                this.ops = await dataSource.getActiveOps();
                await this.carregarOpsAbertos();
            } catch (err) {
                const data = err.response?.data;
                const msg = data?.error ?? data?.message ?? err.message ?? "Erro ao encerrar OP no Omie.";
                this.notificationMessage = msg;
                this.$refs.notification.show();
            } finally {
                this.concluindoOmie = false;
            }
        },

        async reopenOp() {
            const opId = this.selectedOpId;
            try {
                const msg = await dataSource.reopenOp(opId);
                this.ops = await dataSource.getActiveOps();
                await this.carregarOpsAbertos();
                this.notificationMessage = msg ?? "OP reaberta com sucesso.";
                this.$refs.notification.show();
                this.clearSelection();
            } catch (e) {
                this.notificationMessage = e.response?.data?.error ?? e.response?.data?.msg ?? "Ocorreu um erro ao reabrir OP.";
                this.$refs.notification.show();
            }
        },

        parseTeamMembersName(activity) {
            const team = activity.team ?? [];
            const employeesNames = team.map((element) => {
                const name = (element.fullName ?? element.name ?? "").toString().split(" ");
                return `${name[0] ?? ""} ${name[1] ?? ""}`.trim();
            });

            let concatenatedNames = "";
            for (let i = 0; i < employeesNames.length; i++) {
                if (employeesNames.length > 1 && i === employeesNames.length - 2) {
                    concatenatedNames += `${employeesNames[i]} e `;
                } else if (i === employeesNames.length - 1) {
                    concatenatedNames += `${employeesNames[i]}.`;
                } else {
                    concatenatedNames += `${employeesNames[i]}, `;
                }
            }
            return concatenatedNames || "-";
        },

        toggleTeamDropdown(activity) {
            activity.isDropdownVisible = !activity.isDropdownVisible;
        },

        selectEmployee(activity, employee) {
            let isOnTeam = this.isEmployeeOnTeam(activity, employee);

            if (isOnTeam) {
                activity.team = activity.team.filter((ele) => !(ele.id === employee.id));
            } else {
                activity.team.push(employee);
            }
        },

        isEmployeeOnTeam(activity, employee) {
            let isOnTeam = activity.team.some((ele) => ele.id === employee.id);
            return isOnTeam;
        },

        handleFocusOut(activity) {
            activity.isDropdownVisible = false;
        },

        abrirModalPausas(activity) {
            if (activity?.id == null) return;
            this.modalPausasTrabalho = { show: true, trabalhoId: activity.id };
        },

        fecharModalPausasTrabalho() {
            this.modalPausasTrabalho = { show: false, trabalhoId: null };
        },

        onModalPausasError(msg) {
            this.notificationMessage = msg || "Erro ao processar pausas.";
            this.$refs.notification.show();
        },

        onModalPausasSaved() {
            this.notificationMessage = "Registro de pausa/retomada atualizado.";
            this.$refs.notification.show();
        },

        handleClickOutside() {
            this.activities.forEach((a) => {
                if (a.isDropdownVisible) a.isDropdownVisible = false;
            });
        },
    },

    mounted() {
        document.addEventListener("mouseup", this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener("mouseup", this.handleClickOutside);
    },
};
</script>

<style scoped>
.painel-edicao-tipo-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 14px;
}

.painel-edicao-op-picker {
    max-width: min(100%, 42rem);
}

.painel-edicao-op-picker-linha {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    flex-wrap: wrap;
}

.painel-edicao-op-picker-linha :deep(> div:first-of-type) {
    flex: 1 1 16rem;
    min-width: 12rem;
    max-width: 100%;
}

.painel-edicao-op-limpar {
    flex-shrink: 0;
    margin-top: 4px;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid var(--cor-separador, rgba(0, 0, 0, 0.15));
    background: transparent;
    color: var(--cor-fonte-fraca, rgba(0, 0, 0, 0.55));
    font-size: 0.85rem;
    cursor: pointer;
}

.painel-edicao-op-limpar:hover {
    background: var(--cor-primaria-fraca, rgba(0, 0, 0, 0.04));
    color: var(--cor-fonte, inherit);
}

.painel-edicao-op-abertos {
    margin-top: 14px;
    padding-top: 12px;
    border-top: 1px solid var(--cor-separador, rgba(0, 0, 0, 0.12));
}

.painel-edicao-op-abertos__titulo {
    margin: 0 0 8px;
}

.painel-edicao-op-abertos__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
}

.painel-edicao-op-chip {
    border: 1px solid var(--cor-separador, rgba(0, 0, 0, 0.18));
    background: var(--cor-cinza, rgba(0, 0, 0, 0.04));
    color: var(--cor-fonte-forte, inherit);
    border-radius: 999px;
    padding: 6px 14px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    line-height: 1.2;
}

.painel-edicao-op-chip:hover {
    background: var(--cor-primaria-fraca, rgba(0, 0, 0, 0.06));
    border-color: var(--cor-primaria, #3b82f6);
}

.painel-edicao-op-chip--ativo {
    background: var(--cor-primaria, hsl(216 64% 52%));
    border-color: var(--cor-primaria-forte, hsl(216 64% 40%));
    color: #fff;
}

td {
    width: 500px;
}

.painel-edicao-col-maquina {
    min-width: 8rem;
    width: 8rem;
}

/* Peças produzidas, refugo, borra, galho — colunas mais estreitas */
th.painel-edicao-col-num-compact {
    width: 5rem;
    min-width: 4rem;
    max-width: 6rem;
    text-align: left;
    vertical-align: middle;
}

:deep(td.painel-edicao-col-num-compact) {
    width: 5rem;
    min-width: 4rem;
    max-width: 6rem;
    text-align: left;
    vertical-align: middle;
}

:deep(td.painel-edicao-col-num-compact input) {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
    text-align: left;
}

:deep(td.painel-edicao-col-num-compact span) {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}

select {
    border-radius: 10px 10px 0px 0px;
}

option {
    font-size: medium;
    padding: 20px;
    height: 40px;
}

.bg-blue {
    background-color: var(--cor-primaria-media);
}

.bg-yellow {
    background-color: white;
}

.dropdown {
    position: absolute;
}

.dropdown-content {
    z-index: 3;
    position: absolute;
    left: -35px;
    bottom: 45px;
    background-color: #f9f9f9;
    min-width: 250px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    height: 250px;
    overflow-y: scroll;
    border-radius: 10px 10px 0px 0px;
}

.dropdown-content::-webkit-scrollbar {
    display: none;
}

.dropdown-content label {
    padding: 12px 16px;
    display: block;
}

.encerrar-omie-modal {
    text-align: center;
    padding: 8px 0;
    min-width: 360px;
}

.encerrar-omie-modal h3 {
    margin: 0 0 12px;
}

.encerrar-omie-info {
    margin: 8px 0 16px;
    text-align: left;
    color: var(--cor-fonte);
}

.encerrar-omie-field {
    margin-top: 12px;
    text-align: left;
}

.encerrar-omie-field label {
    display: block;
    margin-bottom: 6px;
    font-weight: 600;
}

.encerrar-omie-field textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--cor-separador);
    border-radius: 8px;
    resize: vertical;
    box-sizing: border-box;
    font: inherit;
}

.encerrar-omie-actions {
    justify-content: center;
    gap: 12px;
    margin-top: 20px;
}

.painel-edicao-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

.painel-edicao-col-pausas {
    width: 5rem;
    min-width: 5rem;
    max-width: 6rem;
    text-align: center;
    vertical-align: middle;
}

.painel-edicao-btn-pausas {
    padding: 6px 10px;
    border-radius: 8px;
    border: 1px solid var(--cor-separador, rgba(0, 0, 0, 0.15));
    background: var(--cor-bg, #fff);
    color: var(--cor-primaria, hsl(216 64% 52%));
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
}

.painel-edicao-btn-pausas:hover {
    background: var(--cor-primaria-fraca, rgba(0, 0, 0, 0.04));
}

.painel-edicao-col-acao {
    width: 5.5rem;
    min-width: 5.5rem;
    max-width: 6.5rem;
    text-align: center;
    vertical-align: middle;
}

.painel-edicao-acoes-linha {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    flex-wrap: nowrap;
}

.painel-edicao-btn-salvar-linha {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: var(--cor-primaria, hsl(216 64% 52%));
    cursor: pointer;
    line-height: 0;
}

.painel-edicao-btn-salvar-linha:hover:not(:disabled) {
    background: var(--cor-primaria-fraca, rgba(0, 0, 0, 0.06));
}

.painel-edicao-btn-salvar-linha:disabled {
    color: var(--cor-fonte-fraca, rgba(0, 0, 0, 0.35));
    cursor: not-allowed;
}

.painel-edicao-icone-salvar {
    display: block;
}

.painel-edicao-salvando {
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1;
    min-width: 1.25rem;
}

.painel-edicao-btn-excluir-linha {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: var(--cor-erro, hsl(0 64% 45%));
    cursor: pointer;
    line-height: 0;
}

.painel-edicao-btn-excluir-linha:hover:not(:disabled) {
    background: rgba(220, 38, 38, 0.08);
}

.painel-edicao-btn-excluir-linha:disabled {
    color: var(--cor-fonte-fraca, rgba(0, 0, 0, 0.35));
    cursor: not-allowed;
}

.painel-edicao-icone-excluir {
    display: block;
}
</style>
